import { render, staticRenderFns } from "./ActiveGoal.vue?vue&type=template&id=6bf0ee52&scoped=true&lang=pug"
import script from "./ActiveGoal.vue?vue&type=script&lang=js"
export * from "./ActiveGoal.vue?vue&type=script&lang=js"
import style0 from "./ActiveGoal.vue?vue&type=style&index=0&id=6bf0ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf0ee52",
  null
  
)

export default component.exports